(window as any)['__Zone_enable_cross_context_check'] = true;
(window as any)['__zone_symbol__PASSIVE_EVENTS'] = ['scroll'];